<template>
  <div class="app-container">
    <!-- 查询区域 -->
    <div class="query-card">
      <el-form inline label-width="90px">
        <el-form-item label="设备名称">
          <el-input v-model="DeviceName" placeholder="请输入设备名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-select v-model="time" placeholder="请选择时间范围" @change="timeChange" style="width: 140px;">
            <el-option label="近一日" :value="0"></el-option>
            <el-option label="近七日" :value="1"></el-option>
            <el-option label="近一个月" :value="2"></el-option>
            <el-option label="近三个月" :value="3"></el-option>
            <el-option label="近半年" :value="4"></el-option>
            <el-option label="近一年" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onChange"
            style="width: 280px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData" style="margin-left: 10px; ">搜索</el-button>
        </el-form-item>
      </el-form>
      <!-- 状态说明 -->
      <div class="status-legend">
        <span class="legend-title">状态说明：</span>
        <div class="legend-item">
          <span class="legend-dot color0"></span>
          <span class="legend-text">生产中</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot color1"></span>
          <span class="legend-text">待机中</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot color2"></span>
          <span class="legend-text">故障中</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot color3"></span>
          <span class="legend-text">关机中</span>
        </div>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div class="data-container">
      <el-empty v-if="data.length === 0" description="暂无数据" :image-size="120"></el-empty>
      <div class="device-card" v-for="(item, index) in data" :key="index">
        <div class="device-info">
          <div class="device-name">
            <i class="el-icon-monitor"></i>
            {{ item.name }}
          </div>
          <div class="info-right">
            <div class="status-details-inline">
              <div
                class="status-tag-inline"
                v-for="color in ['color0', 'color1', 'color2', 'color3']"
                :key="color"
                :class="color"
                v-if="getStatusTotal(item, color) > 0">
                <span class="tag-label">{{ getStatusText(color) }}</span>
                <span class="tag-value">{{ formatTime(getStatusTotal(item, color)) }}</span>
              </div>
            </div>
            <div class="utilization-badge">
              <span class="utilization-label">利用率</span>
              <span class="utilization-value">{{ item.useRate }}%</span>
            </div>
          </div>
        </div>
        <div class="status-bar-container">
          <div
            class="status-segment"
            v-for="(item2, index2) in item.data2"
            :key="index2"
            :class="item2.color"
            :style="{ flex: item2.value }"
            :title="`${getStatusText(item2.color)}: ${formatTime(item2.value / 3600)}`">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/equipment/analysis";

export default {
  name: "analysis",
  data() {
    return {
      DeviceName: "",
      time: 1,  // 默认选择近七日
      dateRange: [],
      data: [],
    }
  },
  beforeMount() {
    // 默认选择近七日
    this.timeChange(1);
  },
  methods: {
    getStatusText(color) {
      const colorTextMap = {
        'color0': '生产中',
        'color1': '待机中',
        'color2': '故障中',
        'color3': '关机中'
      };
      return colorTextMap[color] || '未知';
    },
    getStatusTotal(item, color) {
      if (!item.data2) return 0;
      const total = item.data2
        .filter(d => d.color === color)
        .reduce((sum, d) => sum + d.value, 0);
      // 后端返回的是秒，转为小时
      return Math.round(total / 3600 * 10) / 10;
    },
    formatTime(hours) {
      if (!hours || hours === 0) return '0分钟';
      var h = Math.floor(hours);
      var m = Math.round((hours - h) * 60);
      if (m === 60) { h += 1; m = 0; }
      if (h > 0 && m > 0) return h + '小时' + m + '分钟';
      if (h > 0) return h + '小时';
      return m + '分钟';
    },
    getData() {
      const param = {
        EquipmentName: this.DeviceName || undefined,
        StartTime: this.dateRange && this.dateRange[0] ? this.dateRange[0] : undefined,
        EndTime: this.dateRange && this.dateRange[1] ? this.dateRange[1] + ' 23:59:59' : undefined
      };

      api.getMonitorAnalysis(param).then(res => {
        if (res.Code === 0 && res.Data && res.Data.Data) {
          // Status 到 Color 的映射
          const statusColorMap = {
            0: 'color3',  // 关机中 - 灰色
            1: 'color1',  // 待机中 - 橙色
            2: 'color0',  // 生产中 - 绿色
            3: 'color2'   // 故障中 - 红色
          };

          this.data = res.Data.Data.map(item => {
            const statusItems = item.StatusItems || [];
            return {
              name: item.EquipmentName,
              useRate: item.UseRate.toFixed(1),
              data2: statusItems.map(s => ({
                color: statusColorMap[s.Status] || 'color0',
                value: s.TimeLong,
                rate: s.Rate.toFixed(1)
              }))
            };
          });
        } else {
          this.$message.error(res.Msg || '获取数据失败');
          this.data = [];
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('获取数据失败');
        this.data = [];
      });
    },
    timeChange(e) {
      let today = this.$commonJs.getToday();
      let now = (new Date(today)).getTime();
      let s = "";
      let result = "";
      switch (e) {
        case 0:
          s = new Date(now - 86400000);
          result = this.$commonJs.toDateString(s);
          today = result;
          break;
        case 1:
          s = new Date(now - 7 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 2:
          s = new Date(now - 30 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 3:
          s = new Date(now - 90 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 4:
          s = new Date(now - 180 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 5:
          s = new Date(now - 365 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
      }
      this.dateRange = [result, today];
      this.getData();
    },
    onChange(e) {
      this.time = null;
      if (this.dateRange && this.dateRange.length === 2) {
        this.getData();
      }
    },
  }
};
</script>
<style scoped lang="scss">
.app-container {
  margin: 10px;
  padding: 20px;
  min-height: 100vh;
  background-color: #f5f7fa;
}

// 查询卡片
.query-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

  .el-form {
    margin-bottom: 16px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
    margin-right: 16px;
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-select .el-input__inner {
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;

    &:hover {
      border-color: #c0c4cc;
    }

    &:focus {
      border-color: #409eff;
    }
  }

  ::v-deep .el-button--primary {
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 500;
  }
}

// 状态说明
.status-legend {
  display: flex;
  align-items: center;
  padding-top: 6px;
  border-top: 1px solid #f0f0f0;

  .legend-title {
    font-size: 14px;
    color: #606266;
    font-weight: 500;
    margin-right: 20px;
  }

  .legend-item {
    display: flex;
    align-items: center;
    margin-right: 24px;

    .legend-dot {
      width: 12px;
      height: 12px;
      border-radius: 3px;
      margin-right: 8px;
    }

    .legend-text {
      font-size: 13px;
      color: #606266;
    }
  }
}

// 数据容器
.data-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

// 设备卡片
.device-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  padding: 10px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
}

// 设备信息
.device-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  .device-name {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #303133;

    i {
      font-size: 22px;
      color: #409eff;
      margin-right: 10px;
    }
  }

  .info-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .utilization-badge {
    display: flex;
    align-items: center;
    margin-left:20px;
    padding: 8px 16px;
    background: #667eea;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);

    .utilization-label {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.9);
      margin-right: 8px;
    }

    .utilization-value {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
    }
  }
}

// 内联状态详情
.status-details-inline {
  display: flex;
  gap: 8px;
}

.status-tag-inline {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;

  .tag-label {
    color: rgba(255, 255, 255, 0.9);
    margin-right: 4px;
  }

  .tag-value {
    color: #fff;
    font-weight: 600;
  }
}

// 状态详情
.status-details {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.status-tag {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  min-width: 90px;
  justify-content: center;

  .tag-label {
    color: rgba(255, 255, 255, 0.9);
    margin-right: 6px;
  }

  .tag-value {
    color: #fff;
    font-weight: 600;
    font-size: 15px;
  }
}

// 状态条容器
.status-bar-container {
  display: flex;
  width: 100%;
  height: 24px;
  background-color: #f5f7fa;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 6px;
}

// 状态段
.status-segment {
  height: 100%;
  transition: all 0.3s ease;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
  }

  &:hover {
    filter: brightness(1.1);
  }
}

// 状态详情
.status-details {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.status-tag {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  min-width: 90px;
  justify-content: center;

  .tag-label {
    color: rgba(255, 255, 255, 0.9);
    margin-right: 6px;
  }

  .tag-value {
    color: #fff;
    font-weight: 600;
    font-size: 15px;
  }
}

// 颜色定义
.color0 {
  background-color: #10A580;
}

.color1 {
  background-color: #C3A526;
}

.color2 {
  background-color: #B22849;
}

.color3 {
  background-color: #6F7487;
}

</style>

<style lang="scss">
.app-container {
  background-color: #fff !important;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-form--inline {
  margin-bottom: 4px !important;
}
</style>
